module.exports = __webpack_public_path__ + "static/media/light_fixture_galeon_S.8bc8b74f.jpg";